/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-05-12 15:23:33
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-09-08 11:13:35
 * @FilePath: /bar-front-end/src/api/order/index.ts
 */
import request from '@/axios'

// 预下单订单列表详情
export const getBoothDrinkListApi = (params: any) => {
  return request.get({ url: '/barV2/front/preOrder/detailPage', params })
}

// 卡座预下单订单列表
export const getBoothPreOrderListApi = (params: any) => {
  return request.get({ url: '/barV2/front/preOrder/boothDetailPage', params })
}

// 配餐
export const prepareApi = (params: any) => {
  return request.post({ url: '/barV2/front/pdepOrder/prepare', data: params })
}

// 出餐
export const readyApi = (params: any) => {
  return request.post({ url: '/barV2/front/pdepOrder/ready', data: params })
}

// 酒水调整
export const drinkTuneApi = (params: any) => {
  return request.post({ url: '/barV2/front/pdepOrder/drinkTune', data: params })
}

// 手动结账
export const manualCheckoutApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/manualCheckout', data: params })
}

// 手动打印
export const manualPrintApi = (params: any) => {
  return request.post({ url: '/barV2/front/pdepOrder/manualPrint', data: params })
}

// 退款
export const refundOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/refundOrder/refund', data: params })
}

// 二维码结账下单
export const qrCheckoutApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/qrCheckout', data: params })
}

// 根据id获取订单详情
export const getDetailByIdApi = (params: any) => {
  return request.get({ url: '/barV2/front/checkoutOrder/getDetailById', params })
}

// 根据id获取随行付订单详情(综合付款中微信和支付宝付款后轮训支付结果，使用新的接口，后端这个时候并没有生成随行付订单，所以需要新接口)
export const getSxfOrderDetailByIdApi = (params: any) => {
  return request.get({ url: '/barV2/front/sxfOrder/getDetailById', params })
}

// 结账订单分页列表
export const getCheckoutOrderPageApi = (params: any) => {
  return request.get({ url: '/barV2/front/checkoutOrder/page', params })
}

// 结账订单分页列表(带汇总)
export const getCheckoutOrderPageWithTotalApi = (params: any) => {
  return request.get({ url: '/barV2/front/checkoutOrder/pageWithTotal', params })
}

// 退单分页列表
export const getRefundOrderPageApi = (params: any) => {
  return request.get({ url: '/barV2/front/checkoutOrder/refundOrder/page', params })
}

// 结账订单退款（旧）
export const refundCheckoutOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/refund', data: params })
}

// 关闭结账订单(在客户主动扫二维码交易的情景下取消订单用)
export const closeCheckoutOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/close', data: params })
}

// 扫客户付款码下单
export const custQrCheckoutApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/custQrCheckout', data: params })
}

// 取消扫码结账
export const cancelCustQrCheckoutApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/cancel', data: params })
}

// 随行付订单分页列表  /front/sxfOrder/manualCheckoutPage
export const getSxfOrderPageApi = (params: any) => {
  return request.get({ url: '/barV2/front/sxfOrder/manualCheckoutPage', params })
}

// 随行付订单退款
export const refundSxfOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/sxfOrder/refund', data: params })
}

// 关闭预下单订单
export const closePreOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/preOrder/close', data: params })
}

// 强制关单
export const forceClosePreOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/preOrder/forceClose', data: params })
}

// 出单
export const printOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/pdepOrder/printOrder', data: params })
}

// 拉取待打印任务(WebSocket打印消息可靠投递)
export const pullPrintTasksApi = () => {
  return request.get({ url: '/barV2/front/printTask/pull' })
}

// 回报打印结果(ACK)
export const ackPrintTaskApi = (params: any) => {
  return request.post({ url: '/barV2/front/printTask/ack', data: params })
}

// 任意输入金额扫客户二维码扣款
export const custQrDeductByAnyAmountApi = (params: any) => {
  return request.post({ url: '/barV2/front/sxfOrder/custQrDeductByAnyAmount', data: params })
}

// 综合付款结账
export const comboCheckoutApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/comboCheckout', data: params })
}

// 卡座结账前校验
export const checkCanCheckoutApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/checkCanCheckout', data: params })
}

// 现金退款
export const cashRefundApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/cashRefund', data: params })
}

// 储值卡消费时,向指定手机号发送验证码
export const sendCaptchaToPhoneApi = (params: any) => {
  return request.get({ url: '/barV2/front/prepaidCard/consume/sendCaptchaToPhone', params })
}

//修改下单服务员
export const editOrderUserApi = (params: any) => {
  return request.post({ url: '/barV2/front/preOrder/editOrderUser', data: params })
}

// 快捷小费下单
export const quickTipOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/quickTipOrder', data: params })
}

// 关闭快捷小费订单
export const closeQuickTipOrderApi = (params: any) => {
  return request.post({ url: '/barV2/front/checkoutOrder/closeQuickTipOrder', data: params })
}

// 获取所有小费金额配置列表(按排序号升序)
export const getTipAmountConfigListApi = () => {
  return request.get({ url: '/barV2/front/tipAmountConfig/list' })
}
